(function () {
    'use strict';
    angular
        .module('MW.Influencers.SearchSwitcherController', ['MW.Configuration'])
        .controller('SearchSwitcherController', [
            '$location',
            'MR_SEARCH_URL',
            SearchSwitcherController
        ]);

    function SearchSwitcherController($location, MR_SEARCH_URL) {
        window.location.href = MR_SEARCH_URL;
    }
}());